import { useQuery } from "@tanstack/react-query";
import { Alert, Button } from "react-bootstrap";
import tradeService from "../services/trade.service";
import Loader from "./Spinner.component";
import ErrorPage from "./ErrorPage.component";

import TradesTable from "./uiElements/TradesTable.component";
import Modal from "./uiElements/Modal.component";
import ConfirmDelete from "./uiElements/ConfirmDelete.component";
import { useDeleteTrade } from "../hooks/useDeleteTrade";
import { useEffect, useState } from "react";
import PaginationTab from "./uiElements/PaginationTab.component";

function AllTrades() {
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState("tradeDate");
  const [order, setOrder] = useState("desc");

  const itemsPerPage = localStorage.getItem("paginationConfig");

  const { isLoading, data, error, refetch } = useQuery({
    queryKey: ["trades"],
    queryFn: () => tradeService.getTrades({ itemsPerPage, sort, order, page }),
  });

  useEffect(() => {
    refetch();
  }, [itemsPerPage, sort, order, page, refetch]);

  const { deleteAllTrades, isDeletingAll } = useDeleteTrade();

  if (isLoading) return <Loader />;

  if (error) return <ErrorPage errorCode={500} description={"Something Went Wrong"} />;

  const { trades, totalTradesProfit, totalTradesNumber } = data;

  if (trades?.length === 0) return <Alert>No trades available right now, go to Alerts page to start </Alert>;

  return (
    <div className=" trade-table-container">
      <h3>All Available Trades</h3>
      <hr />
      <div className="mb-3 d-flex gap-5 align-items-center justify-content-between">
        <div>
          <h6>Number of Trades: {totalTradesNumber} trades</h6>

          <h6>
            Total Trades Profit/Loss :
            <span className={totalTradesProfit < 0 ? "text-danger" : "text-success"}>
              {parseInt(totalTradesProfit)}
            </span>
          </h6>
        </div>
        <Modal>
          <Modal.Open opens="Delete-Trade">
            <Button variant="danger">DELETE All</Button>
          </Modal.Open>
          <Modal.Window name="Delete-Trade">
            <ConfirmDelete disabled={isDeletingAll} onConfirm={deleteAllTrades} resourceName={"Trade Journal"} />
          </Modal.Window>
        </Modal>
      </div>
      {data.pagination?.totalItems > itemsPerPage && (
        <div className="d-flex justify-content-end  w-100">
          <PaginationTab page={page} setPage={setPage} pagination={data.pagination} />
        </div>
      )}
      <TradesTable order={order} setOrder={setOrder} setSort={setSort} trades={trades} />
    </div>
  );
}

export default AllTrades;
